import { apiRequest } from '../../../api/client';
import type { EveningReminderSettings, EveningReminderSettingsUpdate } from '../../../api/types';

// PARA-136 — тонкие обёртки над apiRequest для настроек вечернего напоминания.

export async function fetchEveningReminderSettings(): Promise<EveningReminderSettings> {
  return apiRequest<EveningReminderSettings>('/users/me/settings');
}

export async function updateEveningReminderSettings(
  data: EveningReminderSettingsUpdate,
): Promise<EveningReminderSettings> {
  return apiRequest<EveningReminderSettings>('/users/me/settings', {
    method: 'PATCH',
    body: data,
  });
}
